import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { enableAutosave } from '../../redux/actions/general/autosave';
import styles from '../../styles/forms/plans/EditPlanSettingTemplateForm.scss';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import {
  __,
  getActiveStage,
  mapStateToProps,
  transformToListPairs,
} from '../../core/utils';
import { map, get } from 'lodash';
import Input from '../../components/Input';
import Textarea from '../../components/Textarea';
import Select from '../../components/Select';
import GridTable from '../../components/GridTable';

@reduxForm({
  form: 'plan_setting_templates.edit_plan_setting_template',
  //enableReinitialize: true,
})
@withRouter
@mapStateToProps((state) => ({
  table: state.table['plan_setting_templates'],
  user_id: state.auth.id,
}))
@subscribe(Localization, 'localization')
class EditPlanSettingTemplateForm extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  componentDidMount() {
    const { flyout } = this.props.table;
  }

  render() {
    const generateColumns = (count) => {
      const cols = [];
      for (let i = 0; i < count; i++) {
        let n = i;
        let s = '';
        do {
          s = String.fromCharCode(65 + (n % 26)) + s;
          n = Math.floor(n / 26) - 1;
        } while (n >= 0);
        cols.push(s);
      }
      return cols;
    };

    const generateRows = (count) =>
      Array.from({ length: count }, (_, i) => String(i + 1));

    const generateCells = (colCount, rowCount) => {
      const cols = generateColumns(colCount);
      const rows = generateRows(rowCount);
      return cols.flatMap((c) => rows.map((r) => `${c}${r}`));
    };

    const cols = generateColumns(26);
    const rows = generateRows(20);

    const { data } = this.props;

    return (
      <Form onSubmit={this.props.handleSubmit}>
        <div className={styles.form}>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                name='name'
                component={Input}
                label={__('plan-setting-templates.field.name')}
                maxLength={70}
              />
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                name='grid_columns_count'
                component={Select}
                disabled
                label={__('plan-setting-templates.field.grid-columns')}
                searchable
                options={map(cols, (col, i) => {
                  return { value: i + 1, label: col };
                })}
              />
            </div>

            <div className={styles.f1}>
              <Field
                disabled
                name='grid_rows_count'
                component={Select}
                searchable
                noSort
                label={__('plan-setting-templates.field.grid-rows')}
                options={map(rows, (row, i) => {
                  return { value: row, label: row };
                })}
              />
            </div>
          </div>

          {/* <div className={styles.cellsWrapper}>
            <Field
              name={`cells`}
              component={GridTable}
              rows={data?.grid_rows_count}
              cols={data?.grid_columns_count}
            />
          </div> */}

          <div className={styles.cellsWrapper}>
            {map(generateRows(data?.grid_rows_count), (row) => (
              <div className={styles.row} key={row}>
                {map(generateColumns(data?.grid_columns_count), (col) => {
                  const key = `${col}${row}`;
                  return (
                    <div className={styles.cell}>
                      <Field
                        key={key}
                        name={`cells[${key}]`}
                        component={Input}
                        placeholder={key}
                      />
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      </Form>
    );
  }
}

export default EditPlanSettingTemplateForm;
